const MOCK_ROLES = [
  {
    id: "group_admin",
    label: "Group admin",
    description: "All companies, configuration, approvals, finance",
  },
  {
    id: "company_admin",
    label: "Company admin",
    description: "Full access within assigned operating companies",
  },
  {
    id: "order_executive",
    label: "Order executive",
    description: "Create orders, parties, route, containers",
  },
  {
    id: "planner",
    label: "Planner / dispatcher",
    description: "Vehicle availability, container planning, dispatch",
  },
  {
    id: "operations",
    label: "Operations",
    description: "Loading, movement, unloading, POD",
  },
  {
    id: "accountant",
    label: "Accountant",
    description: "Invoice, ledger, receipts, ageing",
  },
  {
    id: "driver",
    label: "Driver",
    description: "Own trip, milestones; buyer name visible per client rule",
  },
  {
    id: "buyer",
    label: "Buyer (party)",
    description:
      "POD and transporter name visible; no internal commercial fields",
  },
  {
    id: "seller",
    label: "Seller (party)",
    description: "Party view; rates hidden per client rule",
  },
  {
    id: "port_member",
    label: "Port member",
    description: "Trips, POD, maps; no seller commercial fields",
  },
  {
    id: "workshop_manager",
    label: "Workshop manager",
    description:
      "Maintenance, job cards, spares, vendors, vehicle release",
  },
];
const ROLE_SENSITIVE = {
  group_admin: new Set([
    "customerRate",
    "transporterCost",
    "cashComponent",
    "margin",
    "creditLimit",
    "bankDetails",
    "pod",
    "buyerName",
    "transporterName",
  ]),
  order_executive: new Set([
    "customerRate",
    "creditLimit",
    "buyerName",
    "transporterName",
    "pod",
  ]),
  planner: new Set(["buyerName", "transporterName"]),
  operations: new Set(["pod", "buyerName", "transporterName"]),
  accountant: new Set([
    "customerRate",
    "transporterCost",
    "cashComponent",
    "margin",
    "creditLimit",
    "bankDetails",
    "pod",
    "buyerName",
    "transporterName",
  ]),
  driver: new Set(["buyerName"]),
  buyer: new Set(["pod", "transporterName", "buyerName"]),
  seller: new Set(["buyerName"]),
  port_member: new Set(["pod", "buyerName", "transporterName"]),
  workshop_manager: new Set([
    "transporterCost",
    "cashComponent",
  ]),
};
const ROLE_MODULES = {
  group_admin: ["phase1", "phase2", "phase3", "phase4", "phase5"],
  company_admin: ["phase1", "phase2", "phase3", "phase4", "phase5"],
  order_executive: ["phase1"],
  planner: ["phase1"],
  operations: ["phase1", "phase2"],
  accountant: ["phase1", "phase2"],
  driver: ["phase1", "phase3"],
  buyer: ["phase1"],
  seller: ["phase1"],
  port_member: ["phase1"],
  workshop_manager: ["phase4"],
};
const PORT_MEMBER_NAV_LABELS = new Set([
  "Trips",
  "Trip history",
  "Trip exceptions",
  "POD inbox",
  "Control tower",
  "Vehicle board",
  "Settings",
  "Company dashboard",
]);
const BUYER_NAV_LABELS = new Set([
  "Orders",
  "Trips",
  "POD inbox",
  "Control tower",
  "Settings",
  "Company dashboard",
]);
const WORKSHOP_MANAGER_NAV_LABELS = new Set([
  "Company dashboard",
  "Maintenance requests",
  "Job cards",
  "Service schedule",
  "Spares & inventory",
  "Breakdowns",
  "Vendor bills",
  "Downtime",
  "Workshop estimates",
  "Workshop escalations",
  "Workshop reports",
  "Settings",
]);
const SELLER_NAV_LABELS = new Set([
  "Orders",
  "Trips",
  "Settings",
  "Company dashboard",
]);
function roleCanSeeField(role, field) {
  if (field === "pod") {
    if (role === "buyer" || role === "port_member") return true;
    if (role === "seller" || role === "driver") return false;
  }
  if (field === "buyerName") {
    if (role === "driver") return true;
  }
  if (field === "transporterName") {
    if (role === "buyer") return true;
    if (role === "driver" || role === "seller") return false;
  }
  if (
    field === "customerRate" ||
    field === "transporterCost" ||
    field === "margin" ||
    field === "cashComponent"
  ) {
    if (
      role === "seller" ||
      role === "buyer" ||
      role === "port_member" ||
      role === "driver"
    ) {
      return false;
    }
  }
  if (field === "creditLimit" || field === "bankDetails") {
    if (
      role === "buyer" ||
      role === "seller" ||
      role === "port_member" ||
      role === "driver"
    ) {
      return false;
    }
  }
  return ROLE_SENSITIVE[role].has(field);
}
function roleDefaultModules(role) {
  return ROLE_MODULES[role];
}
function canWriteOrders(role) {
  return role === "group_admin" || role === "order_executive";
}
function canPlan(role) {
  return role === "group_admin" || role === "planner";
}
function canOperate(role) {
  return role === "group_admin" || role === "operations";
}
function canFinance(role) {
  return role === "group_admin" || role === "accountant";
}
function canEditListRecords(role) {
  return !["driver", "buyer", "seller", "port_member"].includes(role);
}
function canDeleteListRecords(role) {
  return ["group_admin", "order_executive", "accountant", "workshop_manager"].includes(
    role,
  );
}
function isPartyPersona(role) {
  return role === "buyer" || role === "seller" || role === "port_member";
}
function navAllowedForRole(role, itemName) {
  if (role === "driver") {
    return ["Trips", "Settings"].includes(itemName);
  }
  if (role === "port_member") {
    return PORT_MEMBER_NAV_LABELS.has(itemName);
  }
  if (role === "buyer") {
    return BUYER_NAV_LABELS.has(itemName);
  }
  if (role === "seller") {
    return SELLER_NAV_LABELS.has(itemName);
  }
  if (role === "workshop_manager") {
    return WORKSHOP_MANAGER_NAV_LABELS.has(itemName);
  }
  return true;
}
export {
  BUYER_NAV_LABELS,
  MOCK_ROLES,
  PORT_MEMBER_NAV_LABELS,
  SELLER_NAV_LABELS,
  WORKSHOP_MANAGER_NAV_LABELS,
  canFinance,
  canDeleteListRecords,
  canEditListRecords,
  canOperate,
  canPlan,
  canWriteOrders,
  isPartyPersona,
  navAllowedForRole,
  roleCanSeeField,
  roleDefaultModules,
};
